<span class="flex w-full flex-wrap items-baseline justify-end gap-x-1 font-mono">
  @for (segment of segments(); track $index) {
    @if (segment.unit) {
      <span class="whitespace-nowrap"
        >{{ segment.value }}<span class="text-text-tertiary">{{ segment.unit }}</span></span
      >
    } @else {
      <span class="text-text-tertiary">{{ segment.value }}</span>
    }
  }
</span>
